export const GENDERS = {
    MALE: 'MALE',
    FEMALE: 'FEMALE',
    OTHER: 'OTHER',
    RATHER_NOT_SAY: 'RATHER_NOT_SAY'
};
